import React, { useState } from 'react';
import { Button } from './ui/button';
import { toast } from 'sonner';

/**
 * Email-only newsletter signup block used at the bottom of every blog post.
 * Posts to the existing /api/newsletter/signup endpoint (name is optional).
 */
const BlogNewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error('Signup failed');
      toast.success("Thanks for subscribing! You'll hear from me soon.");
      setEmail('');
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      className="mt-16 bg-cream rounded-2xl p-8 md:p-12 text-center"
      data-testid="blog-newsletter-signup"
    >
      <h3 className="font-cormorant-garamond text-3xl md:text-4xl text-navy italic mb-3">
        Stay in the loop
      </h3>
      <p className="text-gray-600 max-w-xl mx-auto mb-6 leading-relaxed">
        Sign up to receive updates, statements and campaigns straight to your inbox.
      </p>
      <form
        onSubmit={handleSubmit}
        className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
      >
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="flex-1 px-4 py-3 rounded-md border border-gray-300 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent"
          data-testid="blog-newsletter-email-input"
          aria-label="Email address"
        />
        <Button
          type="submit"
          disabled={submitting}
          className="bg-gold hover:bg-[#e09f0a] text-white font-bold px-8 py-3 text-sm tracking-wide rounded-md transition-colors disabled:opacity-60"
          data-testid="blog-newsletter-submit-button"
        >
          {submitting ? 'SIGNING UP…' : 'SIGN UP'}
        </Button>
      </form>
    </section>
  );
};

export default BlogNewsletterSignup;
